import { Box, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { ReactComponent as EmailSentSvg } from '@assets/images/undraw_mail_sent.svg';
import { ResponsiveDialog } from '@components/Dialogs/ResponsiveDialog';

interface EmailSentDialogProps {
  open: boolean;
  onClose: () => void;
}

export const EmailSentDialog: React.FC<EmailSentDialogProps> = ({ open, onClose }) => {
  const { formatMessage } = useIntl();

  const title = formatMessage({ id: 'Check your email' });
  const description = formatMessage({
    id: "We've sent you an email with a link to create your account. Check your inbox and use the link to set your password."
  });

  return (
    <ResponsiveDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack alignItems="center" spacing={2} pt={1} pb={1}>
          <Box
            component={EmailSentSvg}
            sx={{
              width: 160,
              height: 'auto',
              color: 'primary.main'
            }}
            aria-hidden
          />
          <Typography variant="body1" color="text.secondary" textAlign="center">
            {description}
          </Typography>
        </Stack>
      </DialogContent>
    </ResponsiveDialog>
  );
};
